interface ErrorResponse {
    code: number;
    message: string;
}

export interface QuickbetXReserveState {
    quickbetXReserveData: any;
    quickbetXReserveDataLoading: boolean;
    quickbetXReservedError: ErrorResponse | null;
}


export enum QuickbetXReserveActionTypes {
    FETCH_QUICKBET_X_RESERVE_DATA = "FETCH_QUICKBET_X_RESERVE_DATA",
    FETCH_QUICKBET_X_RESERVE_DATA_SUCCESS = "FETCH_QUICKBET_X_RESERVE_DATA_SUCCESS",
    FETCH_QUICKBET_X_RESERVE_DATA_ERROR = "FETCH_QUICKBET_X_RESERVE_DATA_ERROR",
}

export type QuickbetXReserveAction =
    | { type: QuickbetXReserveActionTypes.FETCH_QUICKBET_X_RESERVE_DATA }
    | { type: QuickbetXReserveActionTypes.FETCH_QUICKBET_X_RESERVE_DATA_SUCCESS; payload: any[] }
    | { type: QuickbetXReserveActionTypes.FETCH_QUICKBET_X_RESERVE_DATA_ERROR; payload: any };